import { useAppDispatch } from "hooks";
import { useCallback } from "react";
import { hudApi } from "redux/apis";
import { getDIPs, getLimitedDeals } from "redux/slices";

export const useHudActions = () => {
	const dispatch = useAppDispatch();

	const updateHudState = useCallback(() => {
		//!* Get dips after purchase to support concurrent offers
		dispatch(getDIPs());
		//!* Get limited deals after purchase to support concurrent offers
		dispatch(getLimitedDeals());
		//!* Invalidate the endpoint to retrieve the updated icon state
		dispatch(hudApi.util.invalidateTags(["hudTag"]));
	}, [dispatch]);

	return { updateHudState };
};
